import React, { useState, useContext, useEffect , useRef } from "react";

import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Row, Col, Table, CardBody, Card, CardHeader } from "reactstrap";

import { Modal, ModalHeader, ModalBody,  } from "reactstrap";
import MaterialComponent from "../LearnerAssesment/MaterialComponent";
import Spinner from "../../sample/spinner";
import MaterialTable from "material-table";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import ReceiptIcon from "@material-ui/icons/Receipt";
import { UserContext } from "../../../context/UserContext";
import { Redirect } from "react-router";
//import Button from "@material-ui/core/Button";
import "../../../css/course-catelog.css";
import { toast } from "react-toastify";
const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)   
const Transactionpage = () => {
  const context = useContext(UserContext);
 
  const [uniqtrans, setUniqtrans] = useState([]);
  const [transinfo, setTransinfo] = useState([]);
  const [pdfpath, setPdfpath] = useState("");
  const [showComponent, setShowComponent] = useState(false);
  const [modalIsOpen, setIodalIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const myRef = useRef(null)

  useEffect(() => {
    // Update the document title using the browser API
    viewtransaction();
  }, []);
  const viewtransaction = async () => {
    axios
      .post("LearnerProfile/transactionsdetails")
      .then((res) => {
        if (res.data.status === "200") {
         
          setUniqtrans(res.data.uniqtrans);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };



 const openModal = (e, pdfpath) =>{
  setIodalIsOpen(true);
  setPdfpath(pdfpath);
}
const closeModal = (e, pdfpath) =>{
  setIodalIsOpen(false);
 
}
const handleClick = (e, ptid) =>{
  setShowComponent(true);
  gettransactiondetails(ptid);
 // console.log(myRef)
 
}

const gettransactiondetails = async (ptid) => {
  setIsLoading(true)
  let formData = new FormData();

  formData.append("tid", ptid);
  axios
    .post("LearnerProfile/transInformation" , formData)
    .then((res) => {
      if (res.data.status === "200") {
       
        setTransinfo(res.data.transinfo);
        setIsLoading(false)
        scrollToRef(myRef);
        return res;
      }
      throw res;
    })
    .catch((error) => {
      console.log("error123", error);
    });
};
if (!context.user?.email) {
  return <Redirect to="/" />
}
  return (
    <div>
   

    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      size="md"
      // style={{height:"10px"}}
      style={{
        top: "1%",
       bottom:"70%",
         height: "60px",
      }}


    >
      <ModalHeader toggle={closeModal} className="header-modalc" > Reciept </ModalHeader>
      <ModalBody >
        <Row>
          <Col xs="10" sm="12" md="12">
            <MaterialComponent
              contentType="contenttype"
              contentId="0"
              materialid="0"
              materialtype="pdf"
              materialpath={pdfpath}
            />
          </Col>
        </Row>
      </ModalBody>
    
    </Modal>

    <section 
        class="padding-default2" >
            <div class="panel panel-primary card">
       
       <div class="panel-heading">My Transactions </div>
     
       <div class="padding-pannele">
      <Row>
        <Col lg={12}>
          <MaterialTable 
            title="My Transactions" 
            columns={[
              { title: "Sr.No.", field: "srno"  },
              { title: "Order Id", field: "orderid", type: "numeric" },
              { title: "Tracking Id", field: "pttransid", type: "numeric" },
              {
                title: "Amount",
                field: "amount",
              },
              { title: "Date", field: "transactionDate"  },
              { title: "Mode", field: "paymentmode" },
              { title: "Status", field: "statuscode" },

              
            ]
          
          }
            data={uniqtrans}
            actions={[
              {
                //icon: InfoSharpIcon,
                icon: () => <InfoSharpIcon color={'primary' } />,
                tooltip: "info",
                onClick: (event, rowData) =>
                  handleClick(event, rowData.pttransid),
              },
              {
               // icon: ReceiptIcon,
                icon: () => <ReceiptIcon color={'secondary' } />,
                tooltip: "receipt",
                onClick: (event, rowData) =>
                  openModal(event, rowData.path),
              },
            ]}
            options={{
              exportButton: true,
              actionsColumnIndex: -1,
            }}
          />
        </Col>
      </Row>
      <br />
    <br />
      {isLoading ? <Spinner /> : ""}
   
   {showComponent === true ? (
    <div ref={myRef}>
     <section >
       <Row>
         <Col sm={12}>
           <Card>
             <CardHeader>Transaction Information</CardHeader>
             <CardBody>
             <Row>
         <Col sm={12}>
               <Table bordered>
                 <thead style={{backgroundColor:"#337ab7",color:"#fff"}}>
                   <tr>
                     <th>Sr.No.</th>
                     <th>Course</th>
                     <th>Instructor</th>
                     <th>Transaction Date</th>
                     <th>Course Base Price</th>
                     <th>Coupon</th>
                   </tr>
                 </thead>
                 <tbody>
                   {transinfo.map((item, indexitem) => (
                     <>
                       <tr>
                         <th>{indexitem + 1}</th>
                         <th>{item.coursename}</th>
                         <th>
                           {item.firstName} {item.lastName}
                         </th>
                         <th> {item.transactionDate}</th>
                         <th>{item.baseprice}</th>
                         <th>{item.promocode}</th>
                       </tr>
                     </>
                   ))}
                 </tbody>
               </Table>
               </Col>
       </Row>
             </CardBody>
           </Card>
         </Col>
       </Row>

     </section>
     </div>
   ) : (
     ""
   )}
     <br />
  
      </div>
      </div>
    </section>
    

   
  
  </div>
  );
};




export default Transactionpage;
